import angular from 'angular';

angular.module('cxRegistrations', ['commonServices']);
